import { api } from "./customers";
export interface Customer {
  customerName: string;
  age: number;
  sex: string;
  spouseName: string;
  spouseAge: number;
  spouseSex: string;
  yearsMarried: string;
  source: string;
  status: boolean;
  customerStatus: string;
  serviceChoosen: string;
  customerId: number;
  appointmentDate: any;
  appointmentTime: any;
  bloodTestDate: any;
  bloodTestTime: any;
  id: number;
  templateName: string;
}
export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}
export interface AppinmentById {
  status: string;
  message: string;
  data: Customer[];
}
export interface AppinmentleadById {
  status: string;
  message: string;
  data: any;
  length: any;
}
type DasboardCustomersResponse = DashboardCustomersResponse[];
type AppoinmentByidResponse = AppinmentById[];

export const AppoinmentApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAppoinmentList: build.query<DasboardCustomersResponse, any>({
      query: (pagi) =>
        `appointment?page=${pagi?.pageNo}&scheduleDate=${
          pagi?.date?.startDate ? pagi?.date?.startDate : ""
        }&reScheduleDate=${
          pagi?.date?.endDate ? pagi?.date?.endDate : ""
        }&name=${pagi?.name}`,
      providesTags: (result) =>
        result
          ? [
              ...result?.["data"]?.map(({ id }) => ({
                type: "DasboardCustomers" as const,
                id,
              })),
              { type: "DasboardCustomers", id: "LIST" },
            ]
          : [{ type: "DasboardCustomers", id: "LIST" }],
    }),
    getPatientDetailsbyId: build.query<AppoinmentByidResponse, any>({
      query: (id) => `appointment_dashboard/${id}`,
      providesTags: ["Reports"],
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
    }),
    getBloodPatientDetailsbyId: build.query<AppoinmentByidResponse, any>({
      query: (id) => `blood_test_collections/${id}`,
      providesTags: ["Reports"],
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
    }),
    getAppoinmentbyId: build.query<AppoinmentByidResponse, any>({
      query: (id) => `appointment/${id}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
    }),
    getBloodAppoinmentbyId: build.query<AppoinmentByidResponse, any>({
      query: (id) => `blood_test_collections/${id}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
    }),
    getAppoinmentLeadbyId: build.query<AppinmentleadById, any>({
      query: ({ id }) => `appointment_lead/${id}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: AppinmentleadById }, meta, arg) =>
        response.data,
    }),
    getFilterCustomerList: build.query<AppoinmentByidResponse, any>({
      query: (name: any) => `customer_details?filter=${name}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
    }),
    addAppointment: build.mutation<
      AppoinmentByidResponse,
      Partial<AppoinmentByidResponse>
    >({
      query: (body: any) => ({
        url: `appointment`,
        method: "POST",
        body,
      }),
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    addIvfAppointment: build.mutation<
      AppoinmentByidResponse,
      Partial<AppoinmentByidResponse>
    >({
      query: (body: any) => ({
        url: `customer_ivf_appointment`,
        method: "POST",
        body,
      }),
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),

    updateIvfAppointment: build.mutation<void, Partial<any>>({
      query: ({ id, ...patch }) => ({
        url: `customer_ivf_Reschedule_appointment/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    deleteAppointment: build.mutation<{ success: boolean; id: number }, number>(
      {
        query(id) {
          return {
            url: `appointment/${id}`,
            method: "DELETE",
          };
        },
        invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
      }
    ),
    // ----------------------------- New Appointments
    getConsultantLists: build.query<any, any>({
      query: () => `branch_besed_consultant`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
    getPatientDetails: build.query<any, any>({
      query: () => `customer_details`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
    getPatientDetailsById: build.query<any, any>({
      query: (id) => `customer_details?customerId=${id}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
    getTimeSlots: build.query<any, { id: number; date: string; type: string }>({
      query: ({ id, date, type }) =>
        `consultant-schedules?consultantId=${id}&scheduledDate=${date}&consultantType=${type}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: any }) => response.data,
    }),
    CreateNewAppointment: build.mutation<any, any>({
      query: (body: any) => ({
        url: `appointment`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),

    getAllNewAppointments: build.query<any, any>({
      query: (pagi) =>
        `appointment?page=${pagi.pageNo}&size=${pagi.size}&filter=${pagi.name}&scheduleDate=${pagi.scheduleDate}&reScheduleDate=${pagi.reScheduleDate}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: any }, meta, arg) => response,
    }),

    updateAppointment: build.mutation<any, Partial<any>>({
      query: ({ id, ...patch }) => ({
        url: `appointment_status/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    cancelAppointment: build.mutation<any, Partial<any>>({
      query: ({ id, ...patch }) => ({
        url: `appointment/status/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),

    updateRescheduleAppointment: build.mutation<any, Partial<any>>({
      query: ({ id, ...patch }) => ({
        url: `appointment/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    getGoogleMeetLink: build.query<any, any>({
      query: (code) => `auth/callback?code=${code}`,
      providesTags: ["DashBoardLeads"],
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
  }),
});
export const {
  useGetAppoinmentListQuery,
  useGetAppoinmentbyIdQuery,
  useGetBloodAppoinmentbyIdQuery,
  useGetAppoinmentLeadbyIdQuery,
  useGetFilterCustomerListQuery,
  useAddAppointmentMutation,
  useAddIvfAppointmentMutation,
  useUpdateIvfAppointmentMutation,
  useUpdateAppointmentMutation,
  useCancelAppointmentMutation,
  useGetPatientDetailsbyIdQuery,
  useGetBloodPatientDetailsbyIdQuery,
  useDeleteAppointmentMutation,
  useGetConsultantListsQuery,
  useGetPatientDetailsQuery,
  useGetPatientDetailsByIdQuery,
  useGetTimeSlotsQuery,
  useCreateNewAppointmentMutation,
  useGetAllNewAppointmentsQuery,
  useGetGoogleMeetLinkQuery,
  useUpdateRescheduleAppointmentMutation,
} = AppoinmentApi;
